import { DndContext } from "@dnd-kit/core";
import React, {useState, useCallback} from 'react';
import LyricsDroppable from "./lyrics-droppable/LyricsDroppable";
import WordDraggable from "./WordDraggable";
import { ItemTypes } from './ItemTypes.js'

const Connect = ({ scripts, word, handleAnswer }) => {
  const [isDragging, setIsDragging] = useState(false);

  const [words] = useState(word)
  const [droppedBoxNames, setDroppedBoxNames] = useState([])

  function isDropped(boxName) {
    return droppedBoxNames.indexOf(boxName) > -1
  }

  const [scriptItems, setScriptItems] = useState(scripts);

  const analyzeScriptItems = useCallback((scriptItems) => {
    const acceptedValues = [ItemTypes.A, ItemTypes.B];
    
    // Filter scriptItems to get only those with accept values A or B
    const relevantScripts = scriptItems.filter(script => acceptedValues.includes(script.accept));
    
    // Check if all relevant scripts have lastDroppedItem and its type matches accept value
    const allAcceptedItemsPresent = relevantScripts.every(script => {
      return (
        script.lastDroppedItem !== null &&
        script.lastDroppedItem.data?.current?.type === script.accept
      );
    });

    const droppedItemsPresent = () => {
      let count = 0;
      for (let i = 0; i < scriptItems.length; i++) {
        const { lastDroppedItem } = scriptItems[i];
        if (lastDroppedItem !== null && lastDroppedItem !== undefined) {
          count++;
        }
      }
      return count;
    }

    return droppedItemsPresent() === 2 ? allAcceptedItemsPresent : null
  
  }, []);

  const handleDrop = useCallback((over, item) => {
    const name = item.data.current.name;
    const isOver = !!over;
    setDroppedBoxNames(prevNames => {
      let updatedNames;
      if (isOver) {
        const index = prevNames.indexOf(name);
        updatedNames = index === -1 ? [...prevNames, name] : prevNames;
        if (scriptItems.findIndex(script => script.lastDroppedItem?.id !== item.id && script.lastDroppedItem !== null) === over.id) {
          updatedNames.splice(item.name, 1);
        }
      } else {
        updatedNames = prevNames.filter(n => n !== name);
      }
      return updatedNames;
    });
  
    setScriptItems(prevScripts => {
      const updatedScripts = prevScripts.map(script => ({
        ...script,
        lastDroppedItem: script.lastDroppedItem?.id === item.id ? null : script.lastDroppedItem,
      }));
    
      if (isOver) {
        updatedScripts[over.id].lastDroppedItem = item;
      }

      handleAnswer(analyzeScriptItems(updatedScripts));
    
      return updatedScripts;
    });
  }, [scriptItems, analyzeScriptItems, handleAnswer]);

  return (
    <DndContext onDragStart={() => setIsDragging(true)}
      onDragEnd={({over, active}) => {
        handleDrop(over, active)
        setIsDragging(false);
      }}
      onDragCancel={() => setIsDragging(false)}>
      <main className="main inline-flex flex-col items-start gap-4 py-4">
        <div className="word-list-section flex flex-col items-center gap-4">
          <div className="word-list w-full">
            {scriptItems.map((item, idx) => (
              item.content === "" ? <div key={idx} className="line mb-4" /> : item.content === " " ? (<span key={idx}>&nbsp;&nbsp;</span>) : (
                <LyricsDroppable key={idx} id={idx} accept={item.accept} name={item.name} dragging={isDragging}>
                  {item.lastDroppedItem ? (
                    <>
                    <WordDraggable id={item.lastDroppedItem.id} type={item.lastDroppedItem.data.current.type} name={item.lastDroppedItem.data.current.name}/>
                    </>
                  ) : item.content
                  }
                </LyricsDroppable>
              )
            ))}
          </div>
        </div>
        <div className="lyrics-section flex flex-col items-center gap-4 w-full">
          <div className="lyrics-list w-full flex gap-2 h-[34px]">
            {words.map((item, idx) => (
              isDropped(item.name) ? null : <WordDraggable key={idx} id={`draggable-item-${item.index}`} type={item.type} name={item.name}/>
            ))}
          </div>
        </div>
      </main>
    </DndContext>
  );
};

export default Connect;
